import React from 'react';
import { Space, Tag } from 'antd';
import { renderCustomAttributeValue } from '@utils/customAttributeValue';

export interface CustomAttributesTagsProps {
  attributes?: Record<string, unknown> | null;
  attributeLabelByName?: Record<string, string>;
  emptyFallback?: React.ReactNode;
  size?: [number, number] | number;
}

const isBlankValue = (value: unknown): boolean => {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string') return value.trim() === '';
  return false;
};

export const visibleCustomAttributeEntries = (
  attributes?: Record<string, unknown> | null,
): Array<[string, unknown]> => {
  if (!attributes || typeof attributes !== 'object') return [];
  return Object.entries(attributes).filter(([, value]) => !isBlankValue(value));
};

export const hasVisibleCustomAttributes = (
  attributes?: Record<string, unknown> | null,
): boolean => visibleCustomAttributeEntries(attributes).length > 0;

export const CustomAttributesTags: React.FC<CustomAttributesTagsProps> = ({
  attributes,
  attributeLabelByName,
  emptyFallback = '-',
  size = [4, 4],
}) => {
  const entries = visibleCustomAttributeEntries(attributes);

  if (entries.length === 0) {
    return <>{emptyFallback}</>;
  }

  return (
    <Space wrap size={size}>
      {entries.map(([key, value]) => (
        <Tag key={key} style={{ margin: 0 }}>
          {attributeLabelByName?.[key] ?? key}: {renderCustomAttributeValue(value)}
        </Tag>
      ))}
    </Space>
  );
};

export default CustomAttributesTags;
